import React from 'react';
import { Container } from '../../shared';
import { Intro } from './intro/intro';
export var HomePage = function () { return (React.createElement(Container, null,
    React.createElement(Intro, null))); };
